import { FunctionComponent } from "react"

import { useResetCallViewHook } from "./hook"
import { StatelessResetView } from "./stateless-reset-view"

const ResetCallView: FunctionComponent = () => {
  const { isLoading, onResetCallView } = useResetCallViewHook()

  return (
    <StatelessResetView isLoading={isLoading} onRefreshPage={onResetCallView} />
  )
}

export default ResetCallView
